<template>
  <div
    id="banner">
    <v-card 
      class="banner-home-image"
      flat
      tile>
      <div
        class="banner-home-image">
      </div>
    </v-card>
    <div
      class="banner-content">
      <v-layout
        wrap
        row
        align-center>
        <v-flex
          style="align-self: center; padding-left: 4vw; padding-right: 4vw"
          xs12
          sm7
          md7>
          <p
            class="banner-name">
            Dr David Aguirre
          </p>
          <p
            class="banner-title">
            Pasión por la Ciencia,
            Amor por mis Pacientes
          </p>
        </v-flex>
        <v-flex
          style="align-self: center;"
          justify-center
          xs12
          sm5
          md5>
          <img 
            style="width: 70%"
            src="/img/static/resume.png" 
            alt="">
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
  }
}
</script>
<style 
  scoped>
  @media screen and (max-width: 600px) {
    .banner-title-br {
      display: none
    }
    .banner-title {
      font-size: 35px !important;
    }
  }

  .banner-home-image {
    background-color: #10458c !important; 
    position: absolute;
    width: 100vw; 
    height: 100vh;
  }
  .banner-name {
    color: white;
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 10px
  }
  .banner-title {
    align-self: center;
    max-width: 100%;
    color: white;
    font-weight: bold;
    font-size: 50px;
    margin-bottom: 30px
  }
  .banner-reserve-button {
    align-self: center;
    width: 120px;
  }
  .banner-reserve-button-text {
    color: #263cc8;
    text-transform: none !important;
    font-weight: bold;
  }
  .banner-content {
    background-color: rgba(0, 0, 0, 0.384);
    position: relative;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #banner {
    position: fixed;
    top: 0;
    height: 100vh;
    min-height: 100vh;
    max-height: 100vh;
    overflow: hidden;
    width: 100%;
    align-content: center;
    justify-content: center;
    z-index: 1
  }
  video {
    object-fit: cover;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
  }
</style>